import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import isEmpty from 'lodash/isEmpty';

class LoanOfficerActionProgressAppResource extends AppResource {

    /**
     *
     * @param value
     */
    setMeta(meta) {
        for (let key in meta) {
            if (
                meta[key] &&
                typeof meta[key] === 'object' &&
                !Array.isArray(meta[key]) &&
                !Object.keys(meta[key]).length
            ) {
                meta[key] = null;
            }

        }
        this.setAttribute('meta', meta);
        this._dirty.meta = true;
    }

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'loan-officer-action-progress';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'loans/officers/actions/progress';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'workspaceUuid',
            'userUuid',
            'actionType',
            'meta',
            'completed',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {};
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {};
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            workspaceUuid: {
                type: 'string',
                presence: true,
            },
            userUuid: {
                type: 'string',
                presence: true,
            },
            actionType: {
                type: 'string',
                presence: true,
            },
            meta: {},
            completed: {
                type: 'boolean',
            },
        };
    }

}

export default LoanOfficerActionProgressAppResource;
